import * as React from 'react';
import { SubscriptionDeliveryIntervalSelect } from '@grandvisionhq/lib-visuals';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import { useProductData } from '../../../../context/product-context-hooks.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';
import '../../../../types/product.js';
import { isSubscriptionPurchase } from '../../../../types/typeguards.js';
import '@grandvisionhq/analytics';
import '@swc/helpers';
import { pushDeliveryIntervalSelectionEvent } from '../../../Analytics/events/subscription-events.js';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/utils';
import { useDeliveryIntervalOptions } from './use-delivery-interval-options.js';

const DeliveryIntervalSelectContainer = ({ className , hasError , deliveryInterval , onIntervalSelection  })=>{
    const { selectedPurchaseType , activeVariant  } = useProductData();
    let availableSubscriptionIntervals;
    if ('availableSubscriptionIntervals' in activeVariant) {
        availableSubscriptionIntervals = activeVariant.availableSubscriptionIntervals;
    }
    const { deliveryIntervalOptions , selectedInterval , singleDeliveryIntervalOption  } = useDeliveryIntervalOptions({
        deliveryInterval,
        availableSubscriptionIntervals
    });
    const handleIntervalSelection = React.useCallback((interval)=>{
        pushDeliveryIntervalSelectionEvent(interval);
        onIntervalSelection(interval);
    }, [
        onIntervalSelection
    ]);
    if (!isSubscriptionPurchase(selectedPurchaseType)) {
        return null;
    }
    if (!deliveryIntervalOptions) {
        console.error(`No delivery interval options or fallback options have been set for sku: '${activeVariant.sku}'`);
        return null;
    }
    return /*#__PURE__*/ React.createElement(SubscriptionDeliveryIntervalSelect, {
        className: className,
        hasError: hasError,
        selectedInterval: selectedInterval,
        singleOptionLabel: singleDeliveryIntervalOption === null || singleDeliveryIntervalOption === void 0 ? void 0 : singleDeliveryIntervalOption.label,
        deliveryIntervalOptions: deliveryIntervalOptions,
        onIntervalSelection: handleIntervalSelection
    });
};

export { DeliveryIntervalSelectContainer };
//# sourceMappingURL=DeliveryIntervalSelectContainer.js.map
